/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBoneTag
 */
export interface CreateBoneTag {
    /**
     * 
     * @type {string}
     * @memberof CreateBoneTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBoneTag
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBoneTag
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBoneTag
     */
    groupsBoneTagIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateBoneTag interface.
 */
export function instanceOfCreateBoneTag(value: object): value is CreateBoneTag {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateBoneTagFromJSON(json: any): CreateBoneTag {
    return CreateBoneTagFromJSONTyped(json, false);
}

export function CreateBoneTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBoneTag {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupsBoneTagIds': json['groupsBoneTagIds'] == null ? undefined : json['groupsBoneTagIds'],
    };
}

export function CreateBoneTagToJSON(json: any): CreateBoneTag {
    return CreateBoneTagToJSONTyped(json, false);
}

export function CreateBoneTagToJSONTyped(value?: CreateBoneTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'imageId': value['imageId'],
        'description': value['description'],
        'groupsBoneTagIds': value['groupsBoneTagIds'],
    };
}

